import {useAgencyInvitesQuery, useAgencyMembersQuery} from "@/api/agencyApi";
import Loader from "@/components/Common/kpi/Loader";
import Modal from "@/components/Common/Modal";
import CompanyMembers from "@/components/MultiAccount/CompanyMembers";
import {useSelectedAgency} from "@/hooks/useUserHooks";
import {isAgencyInviteModalOpenAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const AgencyInviteModal: FC = () => {
  const {t} = useTranslation(["multi_account", "common"]);
  const closeModal = useSetAtom(isAgencyInviteModalOpenAtom);
  const agency = useSelectedAgency();
  const {data: agencyInvites, isPending: isPending1} = useAgencyInvitesQuery({
    agencyId: agency?.id!,
  });
  const {data: agencyMembers, isPending: isPending2} = useAgencyMembersQuery({
    agencyId: agency?.id!,
  });
  return (
    <Modal
      onClose={() => closeModal(false)}
      modalTitle={t("multi_account:invite_modal_title")}
      className="min-h-120"
      backgroundClassName="flex max-w-150"
      customBottomRow={<></>}>
      <div className="flex flex-col gap-5">
        {isPending1 || isPending2 ? (
          <Loader />
        ) : (
          <CompanyMembers
            companyId={agency?.id!}
            companyName={agency?.name ?? ""}
            companyMembers={agencyMembers ?? []}
            companyInvites={
              agencyInvites
                ?.filter(invite => invite.status === "PENDING")
                .map(invite => ({...invite, permission: "ADMIN"})) ?? []
            }
            isAgency
            isLargeBrand={agency?.large_brand}
            upgradePermission={() => {}}
          />
        )}
      </div>
    </Modal>
  );
};

export default AgencyInviteModal;
